import React from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Contactscomponent from '../components/contactscomponent'
import FooterMain from '../components/footer-main'
import './contacts.css'

const Contacts = (props) => {
  return (
    <div className="contacts-container">
      <Helmet>
        <title>Контакты Arcobo | Промышленные роботы в Казахстане</title>
        <meta
          name="description"
          content="Контакты Arcobo для проектов промышленной роботизации, WAAM и автоматизации производства. Офис и производство в Алматы, проекты по Центральной Азии."
        />
        <meta
          property="og:title"
          content="Контакты Arcobo | Промышленные роботы в Казахстане"
        />
        <meta
          property="og:description"
          content="Контакты Arcobo для проектов промышленной роботизации, WAAM и автоматизации производства. Офис и производство в Алматы, проекты по Центральной Азии."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Контакты Arcobo | Промышленные роботы в Казахстане"
        />
        <meta
          name="twitter:description"
          content="Контакты Arcobo для проектов промышленной роботизации, WAAM и автоматизации производства. Офис и производство в Алматы, проекты по Центральной Азии."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/contacts"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/contacts"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Contacts","item":"https://arcobo.tech/contacts"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name24"></HeaderMain>
      <Contactscomponent showText={false} showText1></Contactscomponent>
      <FooterMain rootClassName="footer-mainroot-class-name28"></FooterMain>
    </div>
  )
}

export default Contacts
